import React from 'react'
import WpTag from '../WpTag'

import { WpTagsContainer } from './index.module.css'

const WpTags = ({ tags, location }) => {
  return (
    <div className={WpTagsContainer}>
      {tags.map((tag) => {
        return <WpTag tag={tag} key={tag.id} location={location} />
      })}
    </div>
  )
}

export default WpTags
